import React, { useContext, useEffect } from "react";
import styles from "./styles/SelfRecovery.module.css";
import { UserData } from "../../../Context/DataContext";
import { useState } from "react";
import { decryptText, encryptText } from "../../../Utils/OstreonEncryption";
import { formatTime } from "../../../Utils/formatTime";
import FrequencyPicker from "../Inheritance Tree/FrequencyPicker";
import { useRef } from "react";
import { setSelfRecovery } from "../../../Utils/RenewPWD";
import Confirmation from "../../Confirmation/Confirmation";
import { floatMessage } from "../../../Utils/floatMessage";
import { selfRecoveryTimeOptions } from "../../../Utils/timeOptions";
import { LanguageContext } from "../../../Context/changeLanguageProvider";
import parse from "html-react-parser";
import useWindowDimensions from "../../Footer/footer";

function SelfRecoveryPopUp({ onClose, toEdit, disabled = false }) {
  const [showTopShadow, setShowTopShadow] = useState(false);
  const [showBottomShadow, setShowBottomShadow] = useState(false);
  const divElementRef = useRef(null);
  const websiteCurrentLang = useContext(LanguageContext).language;
  const [showDocument1, setshowDocument1] = useState(false);
  const [showDocument2, setshowDocument2] = useState(false);
  const { width } = useWindowDimensions();
  const [content, setContent] = useState(
    websiteCurrentLang.content.User.SelfRecovery.SelfRecovery
  );
  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );
  useEffect(() => {
    setContent(websiteCurrentLang.content.User.SelfRecovery.SelfRecovery);
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);

  useEffect(() => {
    const divElement = divElementRef.current;

    const handleScroll = () => {
      const scrollTop = divElement.scrollTop;
      const scrollHeight = divElement.scrollHeight;
      const clientHeight = divElement.clientHeight;
      setShowTopShadow(scrollTop > 0);
      setShowBottomShadow(scrollTop + clientHeight < scrollHeight - 10);
    };

    // Call handleScroll once on initial load to set shadows
    handleScroll();

    divElement.addEventListener("scroll", handleScroll);

    return () => {
      divElement.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const one_day = 24 * 60 * 60 * 1000;
  const userData = UserData();
  const [showOptions, setShowOptions] = useState();
  const wrapperRef = useRef();
  const [delay, setDelay] = useState(
    userData?.UserData?.inheritance_parameters?.self_recovery
      ? userData.UserData.inheritance_parameters.self_recovery
      : userData.UserData.inheritance_parameters.priority_one_delay
  );
  const [recoveryData, setRecoveryData] = useState(
    toEdit ? null : { id_type: "IDCard", id_value: "", id_value_confirm: "" }
  );
  const [showConfirmation, setShowConfirmation] = useState(false);

  const [error, setError] = useState({
    id: null,
    id_confirm: null,
  });

  const resetError = () => {
    Object.keys(error).forEach((key) => {
      setError((prevError) => ({ ...prevError, [key]: null }));
    });
  };

  useEffect(() => {
    const handleToEdit = async () => {
      if (toEdit) {
        const id_value = await decryptText(
          userData?.private_key,
          toEdit?.self_recovery_id_private_key
        );
        const id_value_confirm = id_value;
        const id_type = toEdit.id_type;
        setRecoveryData({
          ...toEdit,
          id_value: id_value,
          id_value_confirm: id_value_confirm,
          id_type: id_type,
        });
      }
    };
    handleToEdit();
  }, [userData?.private_key, toEdit]);

  useEffect(() => {
    document.documentElement.style.overflow = "hidden";
    return () => {
      document.documentElement.style.overflow = "unset";
    };
  }, []);
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShowOptions(false);
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [wrapperRef]);
  const handleClick = async () => {
    resetError();
    const newErrors = {};

    if (recoveryData.id_value === "") {
      newErrors.id = content?.selfRecoveryError1;
    }

    if (recoveryData.id_value !== "" && recoveryData.id_value_confirm === "") {
      newErrors.id_confirm =
        dublicatedcontent?.please_confirm_identity_document_number;
    }

    if (
      recoveryData.id_value !== recoveryData.id_value_confirm &&
      recoveryData.id_value_confirm !== ""
    ) {
      newErrors.id_confirm = content?.selfRecoveryError2;
    }

    if (Object.keys(newErrors).length > 0) {
      setError(newErrors);
      setTimeout(() => {
        resetError();
      }, 5000);
      return;
    }

    try {
      const self_recovery_id_private_key = await encryptText(
        userData.private_key,
        recoveryData.id_value
      );
      const private_key_self_recovery_id = await encryptText(
        recoveryData.id_value,
        userData.private_key
      );
      const self_recovery_key = await setSelfRecovery(recoveryData.id_value);
      userData.setUserData({
        ...userData.UserData,
        inheritance_parameters: {
          ...userData.UserData.inheritance_parameters,
          self_recovery: delay,
          self_recovery_day:
            userData.UserData.inheritance_parameters.next_notification +
            Number(delay),
        },
      });
      userData.setCustomerUser({
        ...userData.CustomerUser,
        id_type: recoveryData.id_type,
        id_timestamp: Date.now(),
        self_recovery_key,
        self_recovery_id_private_key,
        private_key_self_recovery_id,
      });
      floatMessage(dublicatedcontent?.saved);
      onClose();
    } catch (e) {
      setError("An error occurred");
      setTimeout(() => {
        setError();
      }, 5000);
    }
  };

  const deleteRecovery = async () => {
    userData.setUserData({
      ...userData.UserData,
      inheritance_parameters: {
        ...userData.UserData.inheritance_parameters,
        self_recovery: delay,
        self_recovery_day: null,
      },
    });
    userData.setCustomerUser({
      ...userData.CustomerUser,
      id_type: null,
      id_timestamp: null,
      self_recovery_key: null,
      self_recovery_id_private_key: null,
      private_key_self_recovery_id: null,
    });
    onClose();
    floatMessage(dublicatedcontent?.deleted);
  };

  return (
    <div className={styles.background}>
      <div
        onClick={(e) => {
          e.stopPropagation();
        }}
        style={
          width <= 599
            ? {
                height: window.innerHeight - 10,
              }
            : {}
        }
        className={styles.main_box}
      >
        <div onClick={onClose} className={styles.close_logo}></div>
        <div className={styles.title}>{content.selfRecoveryText1}</div>

        <div
          className={`${styles.popup_scrollable} ${
            userData.CustomerUser.self_recovery_key
              ? styles.popup_scrollable_edit
              : ""
          }`}
          id="scrollContainer"
          ref={divElementRef}
        >
          <div
            className={`${styles.shadow_top} ${
              showTopShadow ? styles.active : ""
            }`}
          />

          {/* <InfoTitle message={"Lorem ipsum text ..."} title={dublicatedcontent.dublicatedText2} /> */}
          <div className={styles.large_text}>
            {parse(content.selfRecoveryText2)}
          </div>
          <div className={styles.center}>
            <div className={styles.text}>{content.selfRecoveryText3}</div>
            <div className={styles.text}>{content.selfRecoveryText4}</div>
            <div
              ref={wrapperRef}
              style={{
                width: "fit-content",
                position: "relative",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: "5px",
                gap: "12px",
                margin: "0 auto",
              }}
            >
              <div
                onClick={() => {
                  if (!disabled) {
                    setShowOptions(!showOptions);
                  }
                }}
                className={styles.box}
              >
                {formatTime(delay, dublicatedcontent).split(" ")[0]}
              </div>
              <div className={styles.big_text}>
                {formatTime(delay, dublicatedcontent).split(" ")[1]}
              </div>
              {showOptions && (
                <FrequencyPicker
                  time_options={selfRecoveryTimeOptions.filter(
                    (freq) =>
                      freq <
                      userData.UserData.inheritance_parameters
                        .priority_one_delay
                  )}
                  OnSelect={(e) => {
                    setDelay(e);
                    setShowOptions(false);
                  }}
                  timeContent={dublicatedcontent}
                />
              )}
            </div>

            <div className={styles.text}>{content.selfRecoveryText18}</div>
            {userData.UserData.inheritance_parameters.priority_one_delay <
              delay && (
              <div
                className={styles.error_text}
                style={{
                  color: "#FF0000",
                  paddingTop: "5px",
                  paddingBottom: "20px",
                }}
              >
                Must be lower than your priority 1 delay
              </div>
            )}
          </div>
          <div className={styles.auth_title}>{content.selfRecoveryText6}</div>
          <div
            style={{
              display: "flex",
              width: "100%",
              flexWrap: "wrap",
              justifyContent: "space-between",
            }}
          >
            <div className={styles.input_div}>
              <div className={styles.input_title}>
                {content.selfRecoveryText7}
              </div>
              <select
                value={recoveryData?.id_type || "IDCard"}
                onChange={(e) =>
                  setRecoveryData({ ...recoveryData, id_type: e.target.value })
                }
                className={styles.select}
              >
                <option value="IDCard">{content.selfRecoveryText8}</option>
                <option value="Passport">{content.selfRecoveryText9}</option>
                <option value="DrivingLicense">
                  {content.selfRecoveryText10}
                </option>
              </select>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              width: "100%",
              flexWrap: "wrap",
              justifyContent: "space-between",
            }}
          >
            <div className={styles.input_div}>
              <div className={styles.input_title}>
                {content.selfRecoveryText12}
              </div>
              <div style={{ position: "relative" }}>
                <input
                  type={showDocument1 ? "text" : "password"}
                  onChange={(e) =>
                    setRecoveryData({
                      ...recoveryData,
                      id_value: String(e.target.value),
                    })
                  }
                  value={recoveryData?.id_value || ""}
                  className={`${styles.select} ${
                    error.id ? styles.field_error : ""
                  }`}
                  placeholder={content.selfRecoveryText12}
                ></input>
                <div
                  onClick={() => setshowDocument1(!showDocument1)}
                  className={styles.password_button}
                >
                  <svg
                    width="18"
                    height="15"
                    viewBox="0 0 18 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.99994 10.2062C7.20744 10.2062 5.75244 8.99375 5.75244 7.5C5.75244 6.00625 7.20744 4.79375 8.99994 4.79375C10.7924 4.79375 12.2474 6.00625 12.2474 7.5C12.2474 8.99375 10.7924 10.2062 8.99994 10.2062ZM8.99994 5.73125C7.82994 5.73125 6.87744 6.525 6.87744 7.5C6.87744 8.475 7.82994 9.26875 8.99994 9.26875C10.1699 9.26875 11.1224 8.475 11.1224 7.5C11.1224 6.525 10.1699 5.73125 8.99994 5.73125Z"
                      fill="#B3B3B3"
                    />
                    <path
                      d="M9.00006 13.1375C6.18006 13.1375 3.51756 11.7625 1.68756 9.375C0.892559 8.34375 0.892559 6.6625 1.68756 5.625C3.52506 3.2375 6.18756 1.8625 9.00006 1.8625C11.8126 1.8625 14.4751 3.2375 16.3051 5.625C17.1001 6.65625 17.1001 8.3375 16.3051 9.375C14.4751 11.7625 11.8126 13.1375 9.00006 13.1375ZM9.00006 2.8C6.57756 2.8 4.26006 4.0125 2.64006 6.13125C2.07756 6.8625 2.07756 8.1375 2.64006 8.86875C4.26006 10.9875 6.57756 12.2 9.00006 12.2C11.4226 12.2 13.7401 10.9875 15.3601 8.86875C15.9226 8.1375 15.9226 6.8625 15.3601 6.13125C13.7401 4.0125 11.4226 2.8 9.00006 2.8Z"
                      fill="#B3B3B3"
                    />
                  </svg>
                </div>
              </div>
              <div className={styles.error_message}>{error.id}</div>
            </div>
            <div className={styles.input_div}>
              <div className={styles.input_title}>
                {content.selfRecoveryText11}
              </div>
              <div style={{ position: "relative" }}>
                <input
                  type={showDocument2 ? "text" : "password"}
                  onChange={(e) =>
                    setRecoveryData({
                      ...recoveryData,
                      id_value_confirm: String(e.target.value),
                    })
                  }
                  value={recoveryData?.id_value_confirm || ""}
                  className={`${styles.select} ${
                    error.id_confirm ? styles.field_error : ""
                  }`}
                  placeholder={content.selfRecoveryText12}
                ></input>
                <div
                  onClick={() => setshowDocument2(!showDocument2)}
                  className={styles.password_button}
                >
                  <svg
                    width="18"
                    height="15"
                    viewBox="0 0 18 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.99994 10.2062C7.20744 10.2062 5.75244 8.99375 5.75244 7.5C5.75244 6.00625 7.20744 4.79375 8.99994 4.79375C10.7924 4.79375 12.2474 6.00625 12.2474 7.5C12.2474 8.99375 10.7924 10.2062 8.99994 10.2062ZM8.99994 5.73125C7.82994 5.73125 6.87744 6.525 6.87744 7.5C6.87744 8.475 7.82994 9.26875 8.99994 9.26875C10.1699 9.26875 11.1224 8.475 11.1224 7.5C11.1224 6.525 10.1699 5.73125 8.99994 5.73125Z"
                      fill="#B3B3B3"
                    />
                    <path
                      d="M9.00006 13.1375C6.18006 13.1375 3.51756 11.7625 1.68756 9.375C0.892559 8.34375 0.892559 6.6625 1.68756 5.625C3.52506 3.2375 6.18756 1.8625 9.00006 1.8625C11.8126 1.8625 14.4751 3.2375 16.3051 5.625C17.1001 6.65625 17.1001 8.3375 16.3051 9.375C14.4751 11.7625 11.8126 13.1375 9.00006 13.1375ZM9.00006 2.8C6.57756 2.8 4.26006 4.0125 2.64006 6.13125C2.07756 6.8625 2.07756 8.1375 2.64006 8.86875C4.26006 10.9875 6.57756 12.2 9.00006 12.2C11.4226 12.2 13.7401 10.9875 15.3601 8.86875C15.9226 8.1375 15.9226 6.8625 15.3601 6.13125C13.7401 4.0125 11.4226 2.8 9.00006 2.8Z"
                      fill="#B3B3B3"
                    />
                  </svg>
                </div>
              </div>
              <div className={styles.error_message}>{error.id_confirm}</div>
            </div>
          </div>
          <div
            className={`${styles.shadow_bottom} ${
              showBottomShadow ? styles.active : ""
            } ${
              userData.CustomerUser.self_recovery_key
                ? styles.shadow_bottom_edit
                : ""
            }`}
          />
        </div>

        <div className={styles.actions_toolbar}>
          {userData.CustomerUser.self_recovery_key && (
            <button
              disabled={disabled}
              onClick={() => setShowConfirmation(true)}
              className={styles.red_button}
            >
              {content.selfRecoveryText13}
            </button>
          )}
          <button
            disabled={disabled}
            onClick={onClose}
            className={styles.white_button}
          >
            {content.selfRecoveryText14}
          </button>
          <button
            disabled={disabled}
            onClick={() => handleClick()}
            className={styles.button}
          >
            {content.selfRecoveryText15}
          </button>
        </div>

        <div style={{ position: "relative", zIndex: "7" }}>
          {showConfirmation ? (
            <Confirmation
              OnConfirm={() => {
                deleteRecovery();
                window.scrollTo(0, 0);
              }}
              title={content.selfRecoveryText16}
              cancel_button={dublicatedcontent?.dublicatedText184}
              confirm_button={dublicatedcontent?.delete}
              text={content?.selfRecoveryText17}
              onClose={() => setShowConfirmation(false)}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default SelfRecoveryPopUp;
